<template>
  <div class="model-guide-card card-item" :class="marginClass">
    <div class="instruction-header">
      <i class="fa-solid fa-info-circle me-2 text-info"></i>
      <span class="instruction-title">모델별 연결 방법</span>
    </div>
    <div class="instruction-body">
      <div class="model-section mb-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fa-brands fa-bluetooth-b me-2 text-primary" style="font-size: 1.2rem"></i>
          <h6 class="mb-0 fw-bold">블루투스 (BLE) 연결 모델</h6>
        </div>
        <div class="model-list">
          <div class="model-codes">{{ bleModels }}</div>
          <div class="model-description">
            조명제어기 리셋(RESET) 버튼을 길게 눌러 세팅 모드로 진입한 후, 연결 > 블루투스를 선택하세요.
          </div>
        </div>
      </div>

      <div class="model-section">
        <div class="d-flex align-items-center mb-2">
          <i class="fa-solid fa-wifi me-2 text-success" style="font-size: 1.2rem"></i>
          <h6 class="mb-0 fw-bold">WiFi (AP 모드) 연결 모델</h6>
        </div>
        <div class="model-list">
          <div class="model-codes">{{ wifiModels }}</div>
          <div class="model-description">
            조명제어기 리셋(RESET) 버튼을 길게 눌러 세팅 모드로 진입한 후, 연결 > WiFi를 선택하세요. 조명제어기의 AP(inshowled)에 연결됩니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { CONTROLLER_MODELS } from '@/common/constants';

defineProps({
  /** Bootstrap margin utility (예: mb-2, mb-3 mt-3) */
  marginClass: {
    type: String,
    default: 'mb-2',
  },
});

const formatModels = (list) =>
  (list || []).map((m) => m.desc).join(', ');

const bleModels = computed(() => formatModels(CONTROLLER_MODELS.BLE_SUPPORTED));
const wifiModels = computed(() => formatModels(CONTROLLER_MODELS.WIFI_SUPPORTED));
</script>

<style scoped>
.model-guide-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.model-section {
  padding: 0.5rem 0;
  border-bottom: 1px solid #e9ecef;
}

.model-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.model-list {
  padding-left: 2rem;
}

.model-codes {
  color: #0d6efd;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.5;
}

.model-description {
  font-size: 0.8rem;
  color: #6c757d;
  line-height: 1.5;
  margin-top: 0.35rem;
}
</style>
